import React from 'react';
import styled from 'styled-components';

const AboutContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
`;

const AboutHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const AboutTitle = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #333;
`;

const AboutSubtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  max-width: 800px;
  margin: 0 auto;
`;

const AboutSection = styled.section`
  margin-bottom: 60px;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 30px;
  color: #333;
`;

const StoryContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StoryText = styled.div``;

const StoryImage = styled.div`
  img {
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 30px;
`;

const TeamMember = styled.div`
  text-align: center;
`;

const MemberImage = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MemberName = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 5px;
`;

const MissionSection = styled.div`
  background-color: #f9f9f9;
  padding: 60px;
  border-radius: 10px;
  text-align: center;
`;

const MissionText = styled.p`
  font-size: 1.3rem;
  font-style: italic;
  max-width: 800px;
  margin: 0 auto;
  color: #555;
`;

const About = () => {
  return (
    <AboutContainer>
      <AboutHeader>
        <AboutTitle>About TravelMaker</AboutTitle>
        <AboutSubtitle>
          We're on a mission to transform how people explore and experience new destinations
        </AboutSubtitle>
      </AboutHeader>
      
      <AboutSection>
        <SectionTitle>Our Story</SectionTitle>
        <StoryContent>
          <StoryText>
            <p>
              TravelMaker was born out of a shared passion for travel and technology. Our founders, avid travelers themselves, 
              often found it challenging to truly experience the essence of new cities without spending hours on research or 
              missing out on hidden gems that only locals know about.
            </p>
            <br />
            <p>
              In 2024, after a particularly frustrating trip where they missed several must-see attractions despite extensive 
              planning, they decided there had to be a better way. They envisioned an app that would serve as a personal travel 
              companion, guiding users through cities with local expertise and personalized recommendations.
            </p>
            <br />
            <p>
              After months of development and testing in various cities around the world, TravelMaker was launched with the 
              goal of making travel more enriching, efficient, and enjoyable for everyone.
            </p>
          </StoryText>
          <StoryImage>
            <img src="/images/about-image.jpg" alt="TravelMaker team brainstorming" />
          </StoryImage>
        </StoryContent>
      </AboutSection>
      
      <AboutSection>
        <SectionTitle>Our Mission</SectionTitle>
        <MissionSection>
          <MissionText>
            "To empower travelers to discover the soul of every destination through technology that connects them with local culture, 
            history, and experiences that might otherwise go undiscovered."
          </MissionText>
        </MissionSection>
      </AboutSection>
      
      <AboutSection>
        <SectionTitle>Meet Our Team</SectionTitle>
        <TeamGrid>
          <TeamMember>
            <MemberImage>
              <img src="/images/team-member1.jpg" alt="Team member" />
            </MemberImage>
            <MemberName>Mottakin Chowdhury</MemberName>
          </TeamMember>
          
          <TeamMember>
            <MemberImage>
              <img src="/images/team-member2.jpg" alt="Team member" />
            </MemberImage>
            <MemberName>Nayeem Reza</MemberName>
          </TeamMember>
          
          <TeamMember>
            <MemberImage>
              <img src="/images/team-member3.jpg" alt="Team member" />
            </MemberImage>
            <MemberName>Shariful Islam Foysal</MemberName>
          </TeamMember>
        </TeamGrid>
      </AboutSection>
    </AboutContainer>
  );
};

export default About;